import { combineReducers } from 'redux';

import auth from './auth';
import siteInfo from './siteInfo';
import profile from './profile';
import locale from './locale';
import signup from './signup';
import facebookAuth from './facebookAuth';

/* --- selectize reducers that should be combined */
import regions from './regions';
import district from './district';
import schools from './schools';
/* --- selectize reducers --- */

import curriculum from './curriculum';
import sendEmail from './sendEmail';
import resendPhoneVerification from './resendPhoneVerification';
import resetPassword from './resetPassword';
import resetEmail from './resetEmail';
import editAccount from './editAccount';
import purchaseHistory from './purchaseHistory';
import cancelSubscription from './cancelSubscription';
import alertBanner from './alertBanner';
import alertModal from './alertModal';
import modifySubscription from './modifySubscription';
import location from './location';
import redeemReferralCode from './redeemReferralCode';
import resetUnauthedPassword from './resetUnauthedPassword';
import confirmEmail from './confirmEmail';
import plans from './plans';
import purchaseReducers from './purchase';
import forgotPassword from './forgotPassword';
import updatePhone from './updatePhone';
import changeSchool from './changeSchool';
import marketingBanner from './marketingBanner';
import googleTagManager from './googleTagManager';
import footer from './footer';
import deleteAccount from './deleteAccount';
import tutorAudit from './tutorAudit';
import discountCode from './discountCode';
import termsDialog from './termsDialog';
import error from './error';
import report from './report';
import promotionBanner from './promotionBanner';
import tutorList from './tutorList';
import bank from './bank';
import premiumPage from './premiumPage';
import annualConsent from './annualConsent';
import socialWidget from './socialWidget';

const rootReducer = combineReducers({
  auth,
  siteInfo,
  profile,
  locale,
  signup,
  facebookAuth,
  regions,
  district,
  schools,
  curriculum,
  sendEmail,
  resendPhoneVerification,
  resetPassword,
  resetEmail,
  editAccount,
  purchaseHistory,
  cancelSubscription,
  alertBanner,
  alertModal,
  modifySubscription,
  location,
  redeemReferralCode,
  resetUnauthedPassword,
  confirmEmail,
  plans,
  forgotPassword,
  updatePhone,
  changeSchool,
  marketingBanner,
  footer,
  googleTagManager,
  deleteAccount,
  tutorAudit,
  discountCode,
  termsDialog,
  error,
  report,
  promotionBanner,
  tutorList,
  bank,
  premiumPage,
  annualConsent,
  socialWidget,
  ...purchaseReducers,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./app/redux/reducers.js